import { Person } from '../types/people';

export const mockPeopleData: Person[] = [
  {
    id: '1',
    firstName: 'John',
    lastName: 'Smith',
    email: 'john.smith@example.com',
    phoneNumber: '(555) 123-4567',
    address: '123 Main St, Seattle, WA\u00A098101',
    state: 'WA',
    avatarUrl: 'https://i.pravatar.cc/150?img=12',
    mostRecentGift: {
      amount: 500,
      date: '2024-10-15',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-20'
  },
  {
    id: '2',
    firstName: 'Sarah',
    lastName: 'Johnson',
    email: 'sarah.j@example.com',
    phoneNumber: '(555) 234-5678',
    address: '456 Oak Ave, Portland, OR 97201',
    state: 'OR',
    avatarUrl: 'https://i.pravatar.cc/150?img=47',
    mostRecentGift: {
      amount: 250,
      date: '2024-10-18',
      fund: 'Mission Fund'
    },
    lastUpdated: '2024-10-22'
  },
  {
    id: '3',
    firstName: 'Michael',
    lastName: 'Williams',
    email: 'mike.w@example.com',
    phoneNumber: '(555) 345-6789',
    address: '789 Pine St, Tacoma, WA 98402',
    state: 'WA',
    avatarUrl: 'https://i.pravatar.cc/150?img=3',
    mostRecentGift: {
      amount: 1000,
      date: '2024-10-10',
      fund: 'Building Fund'
    },
    lastUpdated: '2024-10-19'
  },
  {
    id: '4',
    firstName: 'Emily',
    lastName: 'Davis',
    email: 'emily.davis@example.com',
    phoneNumber: '(555) 456-7890',
    address: '321 Elm St, Bellevue, WA 98004',
    state: 'WA',
    avatarUrl: 'https://i.pravatar.cc/150?img=5',
    mostRecentGift: {
      amount: 150,
      date: '2024-10-20',
      fund: 'Youth Ministry'
    },
    lastUpdated: '2024-10-21'
  },
  {
    id: '5',
    firstName: 'David',
    lastName: 'Martinez',
    email: 'david.m@example.com',
    phoneNumber: '(555) 567-8901',
    address: '654 Cedar Ln, Kirkland, WA 98033',
    state: 'WA',
    avatarUrl: 'https://i.pravatar.cc/150?img=13',
    mostRecentGift: {
      amount: 750,
      date: '2024-10-12',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-18'
  },
  {
    id: '6',
    firstName: 'Jennifer',
    lastName: 'Brown',
    email: '', // Missing email
    phoneNumber: '(555) 678-9012',
    address: '987 Maple Dr, Redmond, WA 98052',
    state: 'WA',
    avatarUrl: 'https://i.pravatar.cc/150?img=9',
    mostRecentGift: {
      amount: 300,
      date: '2024-10-16',
      fund: 'Outreach'
    },
    lastUpdated: '2024-10-23'
  },
  {
    id: '7',
    firstName: 'Robert',
    lastName: 'Anderson',
    email: 'rob.anderson@example.com',
    phoneNumber: '', // Missing phone
    address: '147 Birch St, Everett, WA 98201',
    state: 'WA',
    avatarUrl: 'https://i.pravatar.cc/150?img=33',
    lastUpdated: '2024-10-14'
  },
  {
    id: '8',
    firstName: 'Jessica',
    lastName: 'Taylor',
    email: 'jessica.t@example.com',
    phoneNumber: '(555) 890-1234',
    address: '258 Spruce Ave, Olympia, WA 98501',
    state: 'WA',
    avatarUrl: 'https://i.pravatar.cc/150?img=16',
    mostRecentGift: {
      amount: 200,
      date: '2024-10-19',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-24'
  },
  {
    id: '9',
    firstName: 'Christopher',
    lastName: 'Thomas',
    email: 'chris.thomas@example.com',
    phoneNumber: '(555) 901-2345',
    address: '369 Willow Rd, Spokane, WA 99201',
    state: 'WA',
    avatarUrl: 'https://i.pravatar.cc/150?img=15',
    mostRecentGift: {
      amount: 450,
      date: '2024-10-13',
      fund: 'Music Ministry'
    },
    lastUpdated: '2024-10-17'
  },
  {
    id: '10',
    firstName: 'Amanda',
    lastName: 'Moore',
    email: 'amanda.moore@example.com',
    phoneNumber: '(555) 012-3456',
    address: '', // Missing address
    avatarUrl: 'https://i.pravatar.cc/150?img=10',
    mostRecentGift: {
      amount: 600,
      date: '2024-10-21',
      fund: 'Children\'s Ministry'
    },
    lastUpdated: '2024-10-25'
  },
  {
    id: '11',
    firstName: 'Daniel',
    lastName: 'Jackson',
    email: 'dan.jackson@example.com',
    phoneNumber: '(555) 123-9876',
    address: '852 Poplar St, Bremerton, WA 98310',
    state: 'WA',
    avatarUrl: 'https://i.pravatar.cc/150?img=14',
    lastUpdated: '2024-10-15'
  },
  {
    id: '12',
    firstName: 'Michelle',
    lastName: 'White',
    email: 'michelle.w@example.com',
    phoneNumber: '(555) 234-8765',
    address: '963 Hickory Ln, Federal Way, WA 98003',
    state: 'WA',
    avatarUrl: 'https://i.pravatar.cc/150?img=20',
    mostRecentGift: {
      amount: 350,
      date: '2024-10-17',
      fund: 'Missions Fund'
    },
    lastUpdated: '2024-10-22'
  },
  {
    id: '13',
    firstName: 'James',
    lastName: 'Harris',
    email: 'james.harris@example.com',
    phoneNumber: '(555) 345-7654',
    address: '159 Walnut Ave, Kent, WA 98032',
    state: 'WA',
    avatarUrl: 'https://i.pravatar.cc/150?img=17',
    mostRecentGift: {
      amount: 800,
      date: '2024-10-11',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-20'
  },
  {
    id: '14',
    firstName: 'Lisa',
    lastName: 'Martin',
    email: 'lisa.martin@example.com',
    phoneNumber: '(555) 456-6543',
    address: '357 Chestnut Dr, Auburn, WA 98001',
    state: 'WA',
    avatarUrl: 'https://i.pravatar.cc/150?img=24',
    mostRecentGift: {
      amount: 275,
      date: '2024-10-22',
      fund: 'Building Fund'
    },
    lastUpdated: '2024-10-26'
  },
  {
    id: '15',
    firstName: 'Matthew',
    lastName: 'Garcia',
    email: 'matt.garcia@example.com',
    phoneNumber: '(555) 567-5432',
    address: '468 Sycamore Ct, Renton, WA 98055',
    state: 'WA',
    mostRecentGift: {
      amount: 425,
      date: '2024-10-14',
      fund: 'Youth Ministry'
    },
    lastUpdated: '2024-10-19'
  },
  {
    id: '16',
    firstName: 'Karen',
    lastName: 'Thompson',
    email: 'karen.t@example.com',
    phoneNumber: '(503) 111-2222',
    address: '789 River Rd, Portland, OR 97202',
    state: 'OR',
    mostRecentGift: {
      amount: 325,
      date: '2024-09-28',
      fund: 'General Fund'
    },
    lastUpdated: '2024-09-30'
  },
  {
    id: '17',
    firstName: 'Brian',
    lastName: 'Lee',
    email: '', // Missing email
    phoneNumber: '(206) 333-4444',
    address: '456 Lake St, Seattle, WA 98115',
    // Missing state
    lastUpdated: '2024-10-05'
  },
  {
    id: '18',
    firstName: 'Nancy',
    lastName: 'King',
    email: 'nancy.king@example.com',
    phoneNumber: '(916) 555-6666',
    address: '123 Capitol Ave, Sacramento, CA 95814',
    state: 'CA',
    mostRecentGift: {
      amount: 550,
      date: '2024-10-08',
      fund: 'Mission Fund'
    },
    lastUpdated: '2024-10-12'
  },
  {
    id: '19',
    firstName: 'Timothy',
    lastName: 'Rodriguez',
    email: 'tim.rodriguez@example.com',
    phoneNumber: '(425) 777-8888',
    address: '789 Mountain View Dr, Sammamish, WA 98074',
    state: 'WA',
    mostRecentGift: {
      amount: 900,
      date: '2024-10-24',
      fund: 'Building Fund'
    },
    lastUpdated: '2024-10-25'
  },
  {
    id: '20',
    firstName: 'Patricia',
    lastName: 'Wilson',
    email: 'patricia.wilson@example.com',
    phoneNumber: '(253) 888-9999',
    address: '234 Harbor Blvd, Gig Harbor, WA 98335',
    state: 'WA',
    mostRecentGift: {
      amount: 175,
      date: '2024-10-19',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-23'
  },
  {
    id: '21',
    firstName: 'Kevin',
    lastName: 'Lopez',
    email: 'kevin.lopez@example.com',
    phoneNumber: '(360) 999-0000',
    address: '567 Forest Ln, Vancouver, WA 98660',
    state: 'WA',
    mostRecentGift: {
      amount: 650,
      date: '2024-10-15',
      fund: 'Youth Ministry'
    },
    lastUpdated: '2024-10-20'
  },
  {
    id: '22',
    firstName: 'Angela',
    lastName: 'Hill',
    email: 'angela.h@example.com',
    phoneNumber: '(509) 111-2222',
    address: '890 Valley Rd, Yakima, WA 98901',
    state: 'WA',
    lastUpdated: '2024-10-10'
  },
  {
    id: '23',
    firstName: 'Thomas',
    lastName: 'Scott',
    email: 'thomas.scott@example.com',
    phoneNumber: '(206) 222-3333',
    address: '123 University Ave, Seattle, WA 98105',
    state: 'WA',
    mostRecentGift: {
      amount: 1250,
      date: '2024-10-22',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-26'
  },
  {
    id: '24',
    firstName: 'Rebecca',
    lastName: 'Green',
    email: 'rebecca.green@example.com',
    phoneNumber: '(425) 333-4444',
    address: '456 Tech Pkwy, Redmond, WA 98052',
    state: 'WA',
    mostRecentGift: {
      amount: 400,
      date: '2024-10-17',
      fund: 'Missions Fund'
    },
    lastUpdated: '2024-10-21'
  },
  {
    id: '25',
    firstName: 'Steven',
    lastName: 'Adams',
    email: '',
    phoneNumber: '(253) 444-5555',
    address: '789 Pacific Ave, Tacoma, WA 98402',
    state: 'WA',
    mostRecentGift: {
      amount: 225,
      date: '2024-10-18',
      fund: 'Building Fund'
    },
    lastUpdated: '2024-10-22'
  },
  {
    id: '26',
    firstName: 'Laura',
    lastName: 'Baker',
    email: 'laura.baker@example.com',
    phoneNumber: '(360) 555-6666',
    address: '321 Bridge St, Longview, WA 98632',
    state: 'WA',
    mostRecentGift: {
      amount: 500,
      date: '2024-10-20',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-24'
  },
  {
    id: '27',
    firstName: 'Ryan',
    lastName: 'Nelson',
    email: 'ryan.nelson@example.com',
    phoneNumber: '(425) 666-7777',
    address: '654 Summit Dr, Issaquah, WA 98027',
    state: 'WA',
    mostRecentGift: {
      amount: 850,
      date: '2024-10-16',
      fund: 'Music Ministry'
    },
    lastUpdated: '2024-10-19'
  },
  {
    id: '28',
    firstName: 'Stephanie',
    lastName: 'Carter',
    email: 'stephanie.c@example.com',
    phoneNumber: '',
    address: '987 Lakeside Rd, Bellevue, WA 98006',
    state: 'WA',
    lastUpdated: '2024-10-15'
  },
  {
    id: '29',
    firstName: 'Eric',
    lastName: 'Mitchell',
    email: 'eric.mitchell@example.com',
    phoneNumber: '(206) 777-8888',
    address: '147 Broadway E, Seattle, WA 98102',
    state: 'WA',
    mostRecentGift: {
      amount: 375,
      date: '2024-10-21',
      fund: 'Youth Ministry'
    },
    lastUpdated: '2024-10-25'
  },
  {
    id: '30',
    firstName: 'Nicole',
    lastName: 'Perez',
    email: 'nicole.perez@example.com',
    phoneNumber: '(253) 888-9999',
    address: '258 Market St, Puyallup, WA 98371',
    state: 'WA',
    mostRecentGift: {
      amount: 300,
      date: '2024-10-14',
      fund: 'Outreach'
    },
    lastUpdated: '2024-10-18'
  },
  {
    id: '31',
    firstName: 'Brandon',
    lastName: 'Roberts',
    email: 'brandon.r@example.com',
    phoneNumber: '(425) 999-0000',
    address: '369 Highlands Dr, Bothell, WA 98011',
    state: 'WA',
    mostRecentGift: {
      amount: 725,
      date: '2024-10-23',
      fund: 'Building Fund'
    },
    lastUpdated: '2024-10-27'
  },
  {
    id: '32',
    firstName: 'Melissa',
    lastName: 'Turner',
    email: 'melissa.turner@example.com',
    phoneNumber: '(360) 000-1111',
    address: '',
    state: 'WA',
    mostRecentGift: {
      amount: 450,
      date: '2024-10-12',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-16'
  },
  {
    id: '33',
    firstName: 'Jason',
    lastName: 'Phillips',
    email: 'jason.phillips@example.com',
    phoneNumber: '(509) 111-2222',
    address: '852 Industrial Way, Spokane Valley, WA 99216',
    state: 'WA',
    mostRecentGift: {
      amount: 550,
      date: '2024-10-19',
      fund: 'Mission Fund'
    },
    lastUpdated: '2024-10-23'
  },
  {
    id: '34',
    firstName: 'Amy',
    lastName: 'Campbell',
    email: 'amy.campbell@example.com',
    phoneNumber: '(425) 222-3333',
    address: '963 Canyon Rd, Snoqualmie, WA 98065',
    state: 'WA',
    lastUpdated: '2024-10-11'
  },
  {
    id: '35',
    firstName: 'Gary',
    lastName: 'Parker',
    email: 'gary.parker@example.com',
    phoneNumber: '(253) 333-4444',
    address: '159 Marine Dr, Lakewood, WA 98499',
    state: 'WA',
    mostRecentGift: {
      amount: 275,
      date: '2024-10-20',
      fund: 'Children\'s Ministry'
    },
    lastUpdated: '2024-10-24'
  },
  {
    id: '36',
    firstName: 'Rachel',
    lastName: 'Evans',
    email: 'rachel.evans@example.com',
    phoneNumber: '(206) 444-5555',
    address: '357 Queen Anne Ave N, Seattle, WA 98109',
    state: 'WA',
    mostRecentGift: {
      amount: 1100,
      date: '2024-10-25',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-28'
  },
  {
    id: '37',
    firstName: 'Jeffrey',
    lastName: 'Edwards',
    email: 'jeff.edwards@example.com',
    phoneNumber: '(425) 555-6666',
    address: '468 Tech Center Dr, Bellevue, WA 98004',
    state: 'WA',
    mostRecentGift: {
      amount: 625,
      date: '2024-10-13',
      fund: 'Building Fund'
    },
    lastUpdated: '2024-10-17'
  },
  {
    id: '38',
    firstName: 'Kimberly',
    lastName: 'Collins',
    email: '',
    phoneNumber: '(360) 666-7777',
    address: '579 Riverfront Blvd, Vancouver, WA 98660',
    state: 'WA',
    mostRecentGift: {
      amount: 350,
      date: '2024-10-16',
      fund: 'Music Ministry'
    },
    lastUpdated: '2024-10-20'
  },
  {
    id: '39',
    firstName: 'Andrew',
    lastName: 'Stewart',
    email: 'andrew.stewart@example.com',
    phoneNumber: '(253) 777-8888',
    address: '680 Industrial Park, Auburn, WA 98001',
    state: 'WA',
    mostRecentGift: {
      amount: 475,
      date: '2024-10-22',
      fund: 'Youth Ministry'
    },
    lastUpdated: '2024-10-26'
  },
  {
    id: '40',
    firstName: 'Christine',
    lastName: 'Sanchez',
    email: 'christine.s@example.com',
    phoneNumber: '(425) 888-9999',
    address: '791 Overlake Blvd, Redmond, WA 98052',
    state: 'WA',
    lastUpdated: '2024-10-14'
  },
  {
    id: '41',
    firstName: 'Scott',
    lastName: 'Morris',
    email: 'scott.morris@example.com',
    phoneNumber: '(206) 999-0000',
    address: '802 Fremont Ave N, Seattle, WA 98103',
    state: 'WA',
    mostRecentGift: {
      amount: 800,
      date: '2024-10-18',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-22'
  },
  {
    id: '42',
    firstName: 'Donna',
    lastName: 'Rogers',
    email: 'donna.rogers@example.com',
    phoneNumber: '(360) 000-1111',
    address: '913 Cascade Dr, Bellingham, WA 98225',
    state: 'WA',
    mostRecentGift: {
      amount: 425,
      date: '2024-10-15',
      fund: 'Missions Fund'
    },
    lastUpdated: '2024-10-19'
  },
  {
    id: '43',
    firstName: 'Paul',
    lastName: 'Reed',
    email: 'paul.reed@example.com',
    phoneNumber: '',
    address: '124 Downtown Ave, Everett, WA 98201',
    state: 'WA',
    mostRecentGift: {
      amount: 575,
      date: '2024-10-21',
      fund: 'Building Fund'
    },
    lastUpdated: '2024-10-25'
  },
  {
    id: '44',
    firstName: 'Janet',
    lastName: 'Cook',
    email: 'janet.cook@example.com',
    phoneNumber: '(425) 111-2222',
    address: '235 Garden St, Kirkland, WA 98033',
    state: 'WA',
    mostRecentGift: {
      amount: 250,
      date: '2024-10-17',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-21'
  },
  {
    id: '45',
    firstName: 'Gregory',
    lastName: 'Morgan',
    email: 'greg.morgan@example.com',
    phoneNumber: '(253) 222-3333',
    address: '346 Commerce St, Federal Way, WA 98003',
    state: 'WA',
    mostRecentGift: {
      amount: 700,
      date: '2024-10-23',
      fund: 'Youth Ministry'
    },
    lastUpdated: '2024-10-27'
  },
  {
    id: '46',
    firstName: 'Carolyn',
    lastName: 'Bell',
    email: 'carolyn.bell@example.com',
    phoneNumber: '(509) 333-4444',
    address: '457 Columbia Dr, Richland, WA 99352',
    state: 'WA',
    mostRecentGift: {
      amount: 325,
      date: '2024-10-14',
      fund: 'Outreach'
    },
    lastUpdated: '2024-10-18'
  },
  {
    id: '47',
    firstName: 'Dennis',
    lastName: 'Bailey',
    email: '',
    phoneNumber: '(206) 444-5555',
    address: '',
    mostRecentGift: {
      amount: 900,
      date: '2024-10-24',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-28'
  },
  {
    id: '48',
    firstName: 'Sharon',
    lastName: 'Rivera',
    email: 'sharon.rivera@example.com',
    phoneNumber: '(425) 555-6666',
    address: '679 Maple Valley Hwy, Renton, WA 98057',
    state: 'WA',
    mostRecentGift: {
      amount: 450,
      date: '2024-10-19',
      fund: 'Music Ministry'
    },
    lastUpdated: '2024-10-23'
  },
  {
    id: '49',
    firstName: 'Frank',
    lastName: 'Cooper',
    email: 'frank.cooper@example.com',
    phoneNumber: '(360) 666-7777',
    address: '780 State Ave, Olympia, WA 98501',
    state: 'WA',
    lastUpdated: '2024-10-12'
  },
  {
    id: '50',
    firstName: 'Helen',
    lastName: 'Richardson',
    email: 'helen.r@example.com',
    phoneNumber: '(253) 777-8888',
    address: '891 Pacific Hwy, Kent, WA 98032',
    state: 'WA',
    mostRecentGift: {
      amount: 525,
      date: '2024-10-20',
      fund: 'Children\'s Ministry'
    },
    lastUpdated: '2024-10-24'
  },
  {
    id: '51',
    firstName: 'Raymond',
    lastName: 'Cox',
    email: 'raymond.cox@example.com',
    phoneNumber: '(425) 888-9999',
    address: '902 148th Ave SE, Bellevue, WA 98007',
    state: 'WA',
    mostRecentGift: {
      amount: 775,
      date: '2024-10-16',
      fund: 'Building Fund'
    },
    lastUpdated: '2024-10-20'
  },
  {
    id: '52',
    firstName: 'Deborah',
    lastName: 'Howard',
    email: 'deborah.howard@example.com',
    phoneNumber: '(206) 999-0000',
    address: '113 Greenwood Ave N, Seattle, WA 98103',
    state: 'WA',
    mostRecentGift: {
      amount: 400,
      date: '2024-10-22',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-26'
  },
  {
    id: '53',
    firstName: 'Jerry',
    lastName: 'Ward',
    email: 'jerry.ward@example.com',
    phoneNumber: '(360) 000-1111',
    address: '224 Heritage Ln, Camas, WA 98607',
    state: 'WA',
    mostRecentGift: {
      amount: 650,
      date: '2024-10-15',
      fund: 'Mission Fund'
    },
    lastUpdated: '2024-10-19'
  },
  {
    id: '54',
    firstName: 'Betty',
    lastName: 'Torres',
    email: '',
    phoneNumber: '(425) 111-2222',
    address: '335 Woodinville Dr, Woodinville, WA 98072',
    state: 'WA',
    mostRecentGift: {
      amount: 375,
      date: '2024-10-18',
      fund: 'Youth Ministry'
    },
    lastUpdated: '2024-10-22'
  },
  {
    id: '55',
    firstName: 'Walter',
    lastName: 'Peterson',
    email: 'walter.peterson@example.com',
    phoneNumber: '(253) 222-3333',
    address: '446 South Hill, Puyallup, WA 98373',
    state: 'WA',
    lastUpdated: '2024-10-13'
  },
  {
    id: '56',
    firstName: 'Judith',
    lastName: 'Gray',
    email: 'judith.gray@example.com',
    phoneNumber: '(509) 333-4444',
    address: '557 Lincoln St, Walla Walla, WA 99362',
    state: 'WA',
    mostRecentGift: {
      amount: 500,
      date: '2024-10-21',
      fund: 'General Fund'
    },
    lastUpdated: '2024-10-25'
  },
  {
    id: '57',
    firstName: 'Henry',
    lastName: 'Ramirez',
    email: 'henry.ramirez@example.com',
    phoneNumber: '(206) 444-5555',
    address: '668 Capitol Hill, Seattle, WA 98102',
    state: 'WA',
    mostRecentGift: {
      amount: 825,
      date: '2024-10-17',
      fund: 'Building Fund'
    },
    lastUpdated: '2024-10-21'
  },
  {
    id: '58',
    firstName: 'Sandra',
    lastName: 'James',
    email: 'sandra.james@example.com',
    phoneNumber: '',
    address: '779 Sunset Blvd, Bremerton, WA 98310',
    state: 'WA',
    mostRecentGift: {
      amount: 425,
      date: '2024-10-23',
      fund: 'Missions Fund'
    },
    lastUpdated: '2024-10-27'
  }
];
